import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getEntryList = store => store[NAME].entryList
export const getConceptList = store => store[NAME].conceptList
export const getImputationList = store => store[NAME].imputationList
export const getDistributionList = store => store[NAME].distributionList
export const getConceptsWithoutImputation = store => store[NAME].conceptsWithoutImputation